function calculateReadingTime(articleSelector, wordsPerMinute = 200) {
  const article = document.querySelector(articleSelector);
  if (!article) return 0;
  const text = article.textContent.trim();
  const wordCount = text.split(/\s+/).length;
  const minutes = Math.ceil(wordCount / wordsPerMinute);
  return minutes;
}
document.addEventListener("DOMContentLoaded", () => {
  const minutes = calculateReadingTime("article", 200);
  const displayEl = document.getElementById("reading-time");
  displayEl.textContent = `${minutes} Mins Read Time`;
});
